import { DashBoarddata } from "../Constants/Dashboard";
//Add RelationData
export const addDashboardData = (dashboard) => {
    return {
        type: DashBoarddata.GET_DASHBOARDDATA,
        payload: dashboard
    };
};
